module.exports = __webpack_public_path__ + "static/media/camera.a906ef4f.png";